<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0">Sellers in {{currentOrg.express_name}} </h4>
                <p class="text-muted m-t-0">Click view to see information such as billing info, invoices and more.</p>
            </div>
            <div class="col-4">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body border-top" v-bind:key="index" v-for="(seller, index) in sellers">
                        <div class="row m-b-0">
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="font-weight-bold">Name</span>
                                        <h3 class="font-light m-b-0">{{seller.org_name}}</h3>
                                        <span class="font-weight-bold">DID</span>
                                        <br>
                                        <a v-if="seller.did" :href="explorer+'/identity/'+seller.did" target="_blank">{{seller.did | truncate(30,'')}}...</a>
                                        <span v-else>N/A</span>
                                        <br>
                                        <span class="font-weight-bold">Audit</span>
                                        <br>
                                        <a v-if="seller.audit" :href="seller.audit" target="_blank">{{seller.audit | truncate(30,'')}}...</a>
                                        <span v-else>N/A</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="font-weight-bold">Description</span><br>
                                        <span v-html="seller.org_description" v-if="seller.org_description"></span>
                                        <span v-else>N/A</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span class="font-weight-bold">Address</span>
                                        <address>
                                            <h4 class="font-light m-b-0">{{seller.biz_name}}</h4>
                                            {{seller.line1}}
                                            <br> {{seller.city}} {{seller.postal_code}}
                                            <br> {{seller.country}}
                                        </address>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex ml-auto">
                                    <div>
                                        <span class="font-weight-bold">Actions</span>
                                        <br>
                                        <div aria-label="Button group with nested dropdown" class="btn-group" role="group">
                                            <router-link :to="{ name: 'viewseller', params: { sellerid: seller.id}}" class="btn btn-secondary">View</router-link>
                                            <router-link :to="{ name: 'editseller', params: { sellerid: seller.id}}" class="btn btn-secondary" type="button">Modify</router-link>
                                            <div class="btn-group" role="group">
                                                <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" id="btnGroupDrop1" type="button">
                                                    <i class="fas fa-cog"></i>
                                                </button>

                                                <div aria-labelledby="btnGroupDrop1" class="dropdown-menu">
                                                    <a @click="selectMember(seller)" class="dropdown-item" data-target="#confirmModal" data-toggle="modal" href="javascript:void(0)">Remove from
                                                        plan</a>
                                                    <a class="dropdown-item" href="javascript:void(0)">Billing Info</a>
                                                    <a class="dropdown-item" href="javascript:void(0)">Renew</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog" tabindex="-1">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-body card-blue">
                                    <div class="text-center m-t-20 m-b-10">
                                        <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                        <br><br>
                                        <h4>Are you sure you want to remove {{seller.biz_name}} from plan {{seller.plan_name}}?</h4>
                                        <button @click="removeMember()" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../../common/Blockie";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Partners",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Paginate},
        data() {
            return {
                sellers: [],
                pageCount: 1,
                perPage: 10,
                total: 0,
                seller: {
                    id: null,
                    biz_name: null
                },
                explorer: ''
            };
        },
        mounted() {
            this.explorer = this.$EXPLORER;
            this.getMembers(1);
        },
        methods: {
            async getMembers(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                    .get("/express/" + this.currentOrg.express_id + "/purchases/sellers", {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total   = reply.data.total;
                    this.sellers = reply.data.sellers;
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(err);
                }
            },
            pageHandler(pageNum) {
                this.getMembers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            selectMember(seller) {
                this.seller = seller;
            },
            async removeMember() {
            },
        }
    }
</script>

<style scoped>

</style>
